export default {"src":"/_next/static/media/CLOSE_ICON_WHITE.eaaef28c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};